import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getContinents, saveBatchContinents } from '../../api/continents';
import type { Continent } from '../../types/Continent';
import { t } from '../../i18n/t';

const columnDefs: ColDef<Continent>[] = [
  {
    field: 'continentId',
    headerName: t('continents.columns.continentId'),
    width: 130,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<Continent>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'continentName',
    headerName: t('continents.columns.continentName'),
    flex: 1,
    cellDataType: 'text',
    editable: true,
  },
  {
    field: 'disclosureCodeEnding',
    headerName: t('continents.columns.disclosureCodeEnding'),
    width: 150,
    cellDataType: 'text',
    editable: true,
  },
];

const newRowDefaults = (): Partial<Continent> => ({
  continentId: 0,
  continentName: '',
  disclosureCodeEnding: null,
});

export function ContinentsPage() {
  return (
    <LopCrudPage<Continent>
      resourceCode="continents"
      titleKey="continents.pageTitle"
      idField="continentId"
      getRows={getContinents}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchContinents(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
